var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-default ls-flex-column fill" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "pagetitle h3" }, [
        _vm._v(
          _vm._s(_vm.title) +
            " - " +
            _vm._s(_vm._f("translate")("Editor")) +
            " "
        )
      ])
    ]),
    _c("div", { staticClass: "panel-body ls-flex-column grow-1 fill" }, [
      _c(
        "div",
        {
          staticClass:
            "ls-flex-column fill unscoped--SimplePopup-editor-container"
        },
        [
          _c("lsckeditor", {
            staticClass: "ls-flex-column fill",
            attrs: { editor: _vm.editorObject, config: _vm.editorConfig },
            model: {
              value:
                _vm.abstractObject[_vm.$store.state.activeLanguage][
                  _vm.typeDef
                ],
              callback: function($$v) {
                _vm.$set(
                  _vm.abstractObject[_vm.$store.state.activeLanguage],
                  _vm.typeDef,
                  $$v
                )
              },
              expression: "abstractObject[$store.state.activeLanguage][typeDef]"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "panel-footer" }, [
      _c("div", { staticClass: "ls-flex-row wrap" }, [
        _c("div", { staticClass: "ls-flex-item text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-danger ls-space margin right-5",
              attrs: { type: "button" },
              on: { click: _vm.close }
            },
            [_vm._v(_vm._s(_vm._f("translate")("Cancel")))]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-primary ls-space margin left-5",
              attrs: { type: "button" },
              on: { click: _vm.saveAndClose }
            },
            [_vm._v(_vm._s(_vm._f("translate")("Save and close")))]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }